@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../host-display-block' as *;
@use '../@shared/link.mixin' as *;
@use '../@shared/alert.mixin' as *;

@layer kol-component {
	@include kol-link-styles('kol-link');
	@include kol-alert;
}
